// ProductiveBot Custom JS
// Added: 2026-03-21
// Updated: 2026-04-03 — fix review anchor scroll from homepage

document.addEventListener('DOMContentLoaded', function() {
  // === PRODUCT PAGE: Rating click scrolls to reviews ===
  var rating = document.querySelector('.product-info__highlighted-rating');
  if (rating) {
    rating.style.cursor = 'pointer';
    rating.addEventListener('click', function() {
      var reviews = document.querySelector('.jdgm-review-widget') || document.querySelector('#judgeme_product_reviews');
      if (reviews) {
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Dynamic rating from Judge.me
    var jdgmData = document.querySelector('.jdgm-aggregate-rating-jld');
    if (jdgmData) {
      try {
        var data = JSON.parse(jdgmData.textContent);
        var avgRating = data.aggregateRating && data.aggregateRating.ratingValue;
        if (avgRating) {
          var label = rating.querySelector('.rating__label');
          if (label) {
            label.textContent = avgRating + '/5 rating from verified customers';
          }
        }
      } catch(e) {}
    }
  }

  // === PRODUCT PAGE: Scroll to reviews when arriving via #judgeme_product_reviews ===
  if (window.location.hash === '#judgeme_product_reviews') {
    var scrollAttempts = 0;
    var maxAttempts = 40; // 40 x 250ms = 10 seconds max wait
    var scrollCheck = setInterval(function() {
      scrollAttempts++;
      var reviewWidget = document.querySelector('#judgeme_product_reviews');
      // Check that the widget exists AND has rendered content (not just an empty shell)
      if (reviewWidget && reviewWidget.classList.contains('jdgm--done-setup-widget')) {
        clearInterval(scrollCheck);
        setTimeout(function() {
          reviewWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      } else if (scrollAttempts >= maxAttempts) {
        clearInterval(scrollCheck);
        // Fallback: scroll to whatever exists
        if (reviewWidget) {
          reviewWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }, 250);
  }

  // === PRODUCT PAGE: Mobile line break in verified badge ===
  if (window.innerWidth <= 768) {
    var badge = document.querySelector('.product-info__verified-badge');
    if (badge) {
      var spans = badge.querySelectorAll('span');
      spans.forEach(function(span) {
        if (span.textContent.includes('\u2014')) {
          span.innerHTML = span.textContent.replace('\u2014', '\u2014<br>');
        }
      });
    }
  }

  // === HOME PAGE: Rating links to product page reviews ===
  var heroRating = document.querySelector('.pb-hero-social-proof');
  if (heroRating && window.location.pathname === '/') {
    heroRating.style.cursor = 'pointer';
    heroRating.addEventListener('click', function() {
      window.location.href = '/products/the-productivebot#judgeme_product_reviews';
    });
  }

  // === AUTO-ADD PRIORITY SUPPORT TO CART ===
  // When Mac Mini or Pro Setup is in cart, ensure Priority Support ($0) is included
  var PRIORITY_SUPPORT_VARIANT = 54038903947636;
  var QUALIFYING_VARIANTS = [53884148220276, 53884148875636]; // Mac Mini, Pro Setup

  function ensurePrioritySupport() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasQualifying = cart.items.some(function(item) {
          return QUALIFYING_VARIANTS.indexOf(item.variant_id) !== -1;
        });
        var hasSupport = cart.items.some(function(item) {
          return item.variant_id === PRIORITY_SUPPORT_VARIANT;
        });

        if (hasQualifying && !hasSupport) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: PRIORITY_SUPPORT_VARIANT,
                quantity: 1,
                properties: { '_auto_added': 'true' }
              }]
            })
          }).then(function() {
            // Reload cart page to show the added item
            if (window.location.pathname.includes('/cart')) {
              window.location.reload();
            }
          });
        }
      })
      .catch(function(e) {
        console.log('Priority Support auto-add check failed:', e);
      });
  }

  // Run on cart page
  if (window.location.pathname.includes('/cart')) {
    ensurePrioritySupport();
  }

  // Listen for add-to-cart on product page (delay to let Shopify process first)
  var addForm = document.querySelector('form[action*="/cart/add"]');
  if (addForm) {
    addForm.addEventListener('submit', function() {
      setTimeout(ensurePrioritySupport, 2000);
    });
  }

  // Listen for AJAX cart updates (Impact theme uses these)
  var origFetch = window.fetch;
  window.fetch = function() {
    var result = origFetch.apply(this, arguments);
    var url = arguments[0];
    if (typeof url === 'string' && url.includes('/cart/add') && !url.includes(PRIORITY_SUPPORT_VARIANT)) {
      setTimeout(ensurePrioritySupport, 1500);
    }
    return result;
  };
});



// ---- Mac Studio Variant Content Switcher v2 ----
if (window.location.pathname.indexOf('productivebot-mac-studio-m4') !== -1) {
/**
 * pb-studio-variants.js v2
 * Dynamic content swap for Mac Studio product page variants
 * Selector confirmed: .product-info__description .prose
 */
(function () {
  var VARIANT_CONTENT = {
    // M4 Max · 128GB · 1TB
    '54418159796596': {
      description: '<p><b>Maximum AI Power, On Your Desk.</b> This Mac Studio M4 Max comes with ProductiveBot pre-installed, enhanced, secured, and ready to work. Message it from anywhere using any chat platform. Run a frontier-class 235B local AI model entirely on your hardware — privately, for free, with no monthly bill attached to every query.</p><ul><li>Mac Studio M4 Max (128GB RAM, 1TB SSD, Silver)</li><li>ProductiveBot + Qwen3 235B pre-installed — 235B parameters, GPT-4-class reasoning, on-device forever</li><li>SecuritySuite, TotalRecall memory, and Skill Store pre-configured</li><li>60-Minute Setup Strategy Call + 30-Day Optimization Check-In + ProductiveBot+ Membership included</li></ul><p><em>128GB unified memory runs the full Qwen3 235B model — the most capable local AI available on Apple Silicon.</em></p>'
    },
    // M4 Max · 64GB · 1TB
    '54536090222964': {
      description: '<p><b>Serious AI Power, On Your Desk.</b> This Mac Studio M4 Max comes with ProductiveBot pre-installed, enhanced, secured, and ready to work. Message it from anywhere using any chat platform. Run a frontier-quality 70B local AI model entirely on your hardware — privately, for free, with no monthly bill attached to every query.</p><ul><li>Mac Studio M4 Max (64GB RAM, 1TB SSD, Silver)</li><li>ProductiveBot + Qwen3 72B pre-installed — 70B-class reasoning, complex analysis, on-device forever</li><li>SecuritySuite, TotalRecall memory, and Skill Store pre-configured</li><li>60-Minute Setup Strategy Call + 30-Day Optimization Check-In + ProductiveBot+ Membership included</li></ul><p><em>64GB unified memory runs Qwen3 72B — frontier-quality reasoning for writing, research, strategy, and analysis. Cloud models are one click away when you want absolute best-in-class.</em></p>'
    }
  };

  function updateContent(variantId) {
    var data = VARIANT_CONTENT[String(variantId)];
    if (!data) return;

    // Target the actual description element (confirmed selector)
    var selectors = [
      '.product-info__description .prose',
      '.product-info__description',
      '.product__description .prose',
      '.product__description',
      '[data-product-description] .prose',
      '[data-product-description]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el && el.innerHTML.trim().length > 0) {
        el.innerHTML = data.description;
        break;
      }
    }
  }

  function getSelectedVariantId() {
    // Button-style picker (Impact default)
    var checkedInput = document.querySelector('.variant-input-wrap input:checked, fieldset input:checked');
    if (checkedInput) return checkedInput.value;

    // Select-style picker
    var select = document.querySelector('select[name="id"], input[name="id"]');
    if (select) return select.value;

    return null;
  }

  // Impact theme fires this custom event when variant changes
  document.addEventListener('variant:changed', function(e) {
    var id = e.detail && e.detail.variant && e.detail.variant.id;
    if (id) updateContent(id);
  });

  // Fallback: watch for any input change on variant selectors
  document.addEventListener('change', function(e) {
    var el = e.target;
    if (!el) return;
    var name = el.name || '';
    var isVariantInput = name === 'id' ||
      el.closest('.variant-picker') ||
      el.closest('[data-variant-picker]') ||
      el.closest('fieldset');
    if (isVariantInput) {
      setTimeout(function() {
        var vid = getSelectedVariantId();
        if (vid) updateContent(vid);
      }, 30);
    }
  });

  // Button picker click fallback
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.variant-input-wrap, [data-option-value]');
    if (btn) {
      setTimeout(function() {
        var vid = getSelectedVariantId();
        if (vid) updateContent(vid);
      }, 80);
    }
  });

  // Initial state on page load
  function initContent() {
    var vid = getSelectedVariantId();
    if (vid) {
      updateContent(vid);
    } else {
      // Default to first variant (128GB)
      updateContent('54418159796596');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContent);
  } else {
    initContent();
  }
})();

}
// ---- End Mac Studio Variant Content Switcher v2 ----


/* hermes-marker-20260613-2204 */


/* pb-klaviyo-mobile-popup-guard-20260722 */
/* Root cause: Klaviyo's onsite popup can render a full-viewport overlay
   (very high z-index) on mobile that blocks taps on the header/hamburger
   while it is open. This is a safety net so the popup can never trap the
   page: it guarantees Escape-to-close and a tap-outside-to-close behavior,
   and hard-caps the overlay so it cannot exceed the site header's stacking
   context indefinitely. It does not change Klaviyo's design/targeting. */
(function () {
  function findKlaviyoOverlay() {
    var nodes = document.querySelectorAll('body > *');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.nodeType !== 1) continue;
      var idAttr = (el.id || '') + ' ' + (el.className || '');
      if (!/klaviyo/i.test(idAttr) && !/kl-/i.test(idAttr)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) >= 1000) {
        return el;
      }
    }
    return null;
  }

  function tryDismiss(overlay) {
    if (!overlay) return;
    var closeBtn = overlay.querySelector(
      '[aria-label="Close"], [aria-label="close"], .klaviyo-close-form, ' +
        'button[class*="close" i], [data-testid*="close" i]'
    );
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    // No close control found/reachable — hide defensively rather than
    // leaving the viewport permanently blocked.
    overlay.style.setProperty('display', 'none', 'important');
  }

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var overlay = findKlaviyoOverlay();
      if (overlay) tryDismiss(overlay);
    },
    { passive: true }
  );

  document.addEventListener(
    'click',
    function (e) {
      var overlay = findKlaviyoOverlay();
      if (!overlay) return;
      if (!overlay.contains(e.target)) tryDismiss(overlay);
    },
    { passive: true }
  );

  // Hard safety cap: never let a Klaviyo overlay exceed the header's own
  // stacking context so header controls remain reachable even if a close
  // control is genuinely missing.
  var HEADER_Z_CAP = 1000;
  function capOverlayZIndex() {
    var overlay = findKlaviyoOverlay();
    if (!overlay) return;
    var cs = window.getComputedStyle(overlay);
    if (parseInt(cs.zIndex, 10) > 999999) {
      overlay.style.setProperty('z-index', String(HEADER_Z_CAP + 1), 'important');
    }
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      capOverlayZIndex();
    });
    mo.observe(document.body, { childList: true, subtree: false });
  }
  setTimeout(capOverlayZIndex, 1500);
  setTimeout(capOverlayZIndex, 4000);
})();
